var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppBar'),_c('SideNavigation'),_c('v-main',{staticClass:"background_color overflow-y-auto",staticStyle:{"position":"relative"}},[_c('v-container',{staticClass:"pa-0",staticStyle:{"height":"100% !important","position":"absolute"},attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }